import { global_image_content_1up } from '../../utils/requests/contentstack/contentStackZodSchema';
import type { ImageContent1UpProps } from './ImageContent1Up';
import { getCloudinaryImageFields } from '../../utils/getCloudinaryItem/getCloudinaryItem';

export const imageContent1UpSchema =
  global_image_content_1up.transform<ImageContent1UpProps>(data => ({
    title: data.title,
    items: data.items,
    image: getCloudinaryImageFields({
      alt: data.image.alt,
      cloudinaryField: data.image.src,
      shouldUseV2: true,
    }),
    showItemsDivider: data.show_items_divider,
    imagePlacement: data.image_placement,
  }));
